var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeAndGarden = function SvgHomeAndGarden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-160v-375l-72 55-47-63 439-337 440 336-48 64-392-300-240 184v356h160v80zm540 95q-42 29-92.5 24.5T521-81t-40.5-86.5T505-260q-29-42-24.5-92.5T521-439t86.5-40.5T700-455q42-29 92.5-24.5T879-439t40.5 86.5T895-260q29 42 24.5 92.5T879-81t-86.5 40.5T700-65m0-98 46 32q18 13 39 11t37-18 18-37-11-39l-32-46 32-46q13-18 11-39t-18-37-37-18-39 11l-46 32-46-32q-18-13-39-11t-37 18-18 37 11 39l32 46-32 46q-13 18-11 39t18 37 37 18 39-11zm0-47q21 0 35.5-14.5T750-260t-14.5-35.5T700-310t-35.5 14.5T650-260t14.5 35.5T700-210m0-50"
  })));
};
export default SvgHomeAndGarden;